export default __webpack_public_path__ + "static/12-428db1ef6a8e029b953ff1c93de7c0f3.png";